<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Edit Country" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="edit()" ngNativeValidate>
          <app-country-form [country]="country" *ngIf="country"></app-country-form>
        </form>
      </div>
    </section>
  </div>
</div>
